// @flow
import { API_URL_SET } from '../actions/action-types';
import type { Action, SetApiUrlAction } from '../actions';

const apiUrl = (state: string = '', action: Action): string => {
  switch (action.type) {
    case API_URL_SET:
      // eslint-disable-next-line babel/no-unused-expressions
      ((action: any): SetApiUrlAction);
      return action.payload.apiUrl;
    default:
      return state;
  }
};

export default apiUrl;
